<script>
/**
 * Screen component
 */

import i18n from "../i18n";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      Alert: Swal,
      Locate: i18n,
    };
  },
  mounted() {
    i18n.locale = localStorage.getItem('locale') ? localStorage.getItem('locale') : 'en';
  },
};
</script>